fx.ns("shared", class EditorSaver extends fx.CrudSaver {

    constructor(model) {
        super(model);
    }

    onSaved(data) {
        // special case for columns that accept temporary ids, so we check if we have final id and update it
        // CreationElementContent has 2 temporary ids : pageid, content (in case of photo)

        if (data && data.ids && Object.keys(data.ids).length > 0) 
        {
            for (let i = 0; i < this.lastUpdates.length; i++) 
            {
                if (this.lastUpdates[i].model && this.lastUpdates[i].model._m == "CreationElementContent") 
                {
                    if (data.ids[this.lastUpdates[i].model.creation_element_id])
                        this.lastUpdates[i].model.creation_element_id = data.ids[this.lastUpdates[i].model.creation_element_id];

                    if (this.lastUpdates[i].model.component_type == "photo" && data.ids[this.lastUpdates[i].model.content])
                        this.lastUpdates[i].model.content = data.ids[this.lastUpdates[i].model.content];
                }
            }
        }

        // Safety net for a replayed batch : the editor re-sends a batch when it got no answer to a save
        // (network failure, hop timeout). The server had already processed it, so it answers with every
        // action done but without the ids of the creates. Accepting that answer would clear the creates
        // while their models keep a temporary id, and every later update on them would be silently lost.
        // So the answer is turned into an error : nothing is cleared, the ids that did come back are still
        // applied, and the repository retries / reports the failure as for any failed save.
        if (this._hasCreatesWithoutId(data))
            data = { error : true, details : "replayed-creates-without-ids", ids : data.ids };

        super.onSaved(data);
    }

    /**
     * True when the answer marks as processed a "create" of this batch whose model still carries a temporary
     * id and for which no final id was returned. A create processed for the first time always comes back with
     * its id, so this only matches a create the server had already done in an earlier, unanswered request.
     */
    _hasCreatesWithoutId(data) {
        if (!data || data.error || !Array.isArray(data.actions) || data.actions.length == 0)
            return false;

        let ids = data.ids || {};

        for (let i = 0; i < this.lastUpdates.length; i++) {
            let action = this.lastUpdates[i];

            if (action.type != "create" || !action.forSaving || !action.model)
                continue;

            let id = action.model.id;

            if (typeof id == "string" && id.indexOf(Utils.prefixID) == 0 && !ids[id] && data.actions.indexOf(action.id) != -1)
                return true;
        }

        return false;
    }

    handle(action) {
        if (!action.model)
            return;

        if (action.model._m == "ThemeLayout" && action.type == "update" && fx.get("app") != "config" )
            return;

        if (action.model._m == "ThemeLayoutComponent" && fx.get("app") != "config" )
            return;
        // Exception : Photos are created and deleted by server, Editor only updates photos
        if (action.model._m == "Photo" && (action.type == "create" || action.type == "delete"))
            return;

        // Exception : Zoom is not saved on Server
        if (action.model._m == "Zoom")
            return;

        if (action.model._m == "InstagramPhotoModel" ||
            action.model._m == "FacebookPhotoModel" ||
            action.model._m == "GooglePhotoModel" ||
            action.model._m == "GoogleAlbumModel" ||
            action.model._m == "FacebookAlbumModel" ||
            action.model._m == "Album" ||
            action.model._m == "Settings" ||
            action.model._m == "PhotoAlbum" ||
            (action.model._m == "CustomColor" && action.impactsOnly("id")) ||
            (action.model instanceof models.CreationElementContent && action.model.component_type == "pagination") || // we don't store pagination components
            action.model instanceof repositories.BaseRepository)  // we don't store any updates made directly on BaseRepository
            return;


        super.handle(action);

    }

});